import { toast } from "react-toastify";

export const notifySuccess = (email: string) =>
  toast.success(`${email}`, {
    pauseOnHover: true,
    draggable: true,
    autoClose: 5000,
    closeOnClick: true,
    theme: "colored",
  });

export const notifyError = (message: string) =>
  toast.error(`${message}`, {
    pauseOnHover: true,
    draggable: true,
    autoClose: 5000,
    closeOnClick: true,
    theme: "colored",
  });

export const DefaultErrorMessage = "Opps Some Error Occured Please Try Again";